export default {
  title: '¡Estás a un paso de acceder a todos nuestros programas educativos!',
  repeatedUserWarning: 'Recuerda que si tu centro educativo ya forma parte de la comunidad Kimple, no es necesario que solicites un usuario trial. Pídele a tu equipo directivo que te envíe la invitación para poder generar tu registro y acceder a tus credenciales definitivas.',
  continueWithGoogle: 'Continuar con Google',
  continueWithMicrosoft: 'Continuar con Microsoft',
  schoolInformation: 'Información de la escuela',
  personalInformation: 'Información personal',
  repeatEmailLabel: 'Confirmar correo electrónico',
  repeatEmailError: 'Confirma el correo electrónico',
  passwordMinLengthError: 'Mínimo 6 caracteres',
  passwordUpperLowerError: 'Al menos una mayúscula y una minúscula',
  passwordNumberError: 'Al menos un número',
  repeatEmailDifferentError: 'Los datos ingresados no son correctos',
  repeatEmailPlaceholder: 'Escribe tu correo electrónico',
  titleNewUser: 'Completa tu perfil',
  titleExistingUser: 'Verifica tu perfil antes de confirmar el cambio',
  enterPasswordExistingUser: 'Ingresa tu contraseña para confirmar el cambio',
  button: 'Enviar',
  termsAndConditions: 'Términos y condiciones',
  accept: 'Acepto los ',
  nameAndSurnamePlaceholder: 'Escribe tu nombre',
  nameAndSurnameLabel: 'Nombre y apellido',
  emailLabel: 'Correo electrónico',
  emailPlaceholder: 'Escribe tu correo electrónico',
  schoolNameLabel: 'Nombre de la escuela',
  schoolNamePlaceholder: 'Escribe el nombre de la escuela',
  educationalLevelsLabel: 'Nivel',
  educationalLevelsPlaceholder: 'Seleccione el nivel que imparte la escuela',
  educationalLevelsError: 'Debes seleccionar al menos un nivel',
  chargePlaceholder: 'Cargo que ejerce en la escuela',
  chargeLabel: 'Área',
  bioPlaceholder: 'Escribir una pequeña biografía',
  bioLabel: 'Bio',
  levelPlaceholder: 'Indicar nivel o niveles con los que trabaja',
  levelLabel: 'Nivel',
  subjectPlaceholder: 'Agrega las materias que impartes',
  subjectLabel: 'Materias que impartes',
  phonePlaceholder: 'Ingresar número de teléfono',
  phoneLabel: 'Teléfono',
  passwordPlaceholder: 'Escribe una contraseña',
  passwordLabel: 'Contraseña',
  replacePasswordLabel: 'Repetir contraseña',
  replacePasswordPlaceholder: 'Repite la contraseña',
  replacePasswordError: 'Repite la contraseña',
  replacePasswordDifferentError: 'Los datos ingresados no son correctos',
  bioTip: 'Cuéntanos un poco acerca de quién eres en menos de 400 caracteres.',
  passwordTip: 'Tiene que tener: mínimo 6 caracteres, al menos 1 mayúscula, 1 minúscula y 1 número(0~9).',
  photoLabel: 'Foto de perfil',
  photoButton: 'Cargar foto',
  optional: '(Opcional)',
  characters: 'caracteres',
  passwordErrors: 'Las contraseñas no coinciden. Prueba de nuevo',
  nameAndSurnameError: 'Escribe tu nombre completo para completar tu perfil',
  chargeError: 'Indícanos cuál es tu cargo en la escuela para completar tu perfil',
  photoError: 'No pudimos cargar tu imagen. Prueba cargar otra en formato .PNG o .JPG con un peso menor a 2MB.',
  photoAlt: 'Foto de perfil',
  emailError: 'Escribe tu dirección de correo electrónico.',
  cellPhoneNumberError: 'Escribe un número de teléfono.',
  schoolNameError: 'Escribe el nombre de tu escuela.',
  schoolAddressError: 'Escribe la direccion de tu escuela.',
  termsAndConditionsError: 'Debes aceptar los términos y condiciones',
  duplicatedMail: 'El correo electrónico ya se encuentra registrado',
  duplicatedAddres: 'La dirección ya se encuentra registrada',
  backendOffline: 'No podemos atender tu solicitud, inténtalo más tarde.'
}

export const en = {
  title: 'You are just one step away from accessing all of our educational programs!',
  repeatedUserWarning: 'Remember that if your school is already part of the Kimple community, it is not necessary to request a trial user. Ask your management team to send you the invitation to generate your registration and access your definitive credentials.',
  continueWithGoogle: 'Continue with Google',
  continueWithMicrosoft: 'Continue with Microsoft',
  schoolInformation: 'School information',
  personalInformation: 'Personal information',
  repeatEmailLabel: 'Confirm email address',
  repeatEmailError: 'Confirm email address',
  passwordMinLengthError: 'At least 6 characters',
  passwordUpperLowerError: 'At least one uppercase and one lowercase letter',
  passwordNumberError: 'At least one number',
  repeatEmailDifferentError: 'The data entered are not correct',
  repeatEmailPlaceholder: 'Confirm email address',
  titleNewUser: 'Complete your profile',
  titleExistingUser: 'Check your profile before confirming the change',
  enterPasswordExistingUser: 'Enter your password to confirm the change',
  button: 'Send',
  termsAndConditions: 'Terms and conditions',
  accept: 'I accept the',
  nameAndSurnamePlaceholder: 'Enter your name',
  nameAndSurnameLabel: 'Name and last name',
  emailLabel: 'Email address',
  emailPlaceholder: 'Enter your email address',
  schoolNameLabel: 'School name',
  schoolNamePlaceholder: 'Enter the school name',
  educationalLevelsLabel: 'Level',
  educationalLevelsPlaceholder: 'Select the level the school teaches',
  educationalLevelsError: 'You must select at least one level',
  chargePlaceholder: 'Position at the school',
  chargeLabel: 'Area',
  bioPlaceholder: 'Write a short bio',
  bioLabel: 'Bio',
  levelPlaceholder: 'State the level or levels you teach',
  levelLabel: 'Level',
  subjectPlaceholder: 'Add the subjects you teach',
  subjectLabel: 'Subjects taught',
  phonePlaceholder: 'Enter phone number',
  phoneLabel: 'Phone number',
  passwordPlaceholder: 'Enter password',
  passwordLabel: 'Password',
  replacePasswordLabel: 'Repeat password',
  replacePasswordPlaceholder: 'Repeat password',
  replacePasswordError: 'Repeat password',
  replacePasswordDifferentError: 'The data entered are not correct',
  bioTip: 'Tell us about yourself in less than 400 characters.',
  passwordTip: 'It must have: at least 6 characters, 1 uppercase letter, 1 lowercase letter, and 1 digit (0~9).',
  photoLabel: 'Profile photo',
  photoButton: 'Upload photo',
  optional: '(Optional)',
  characters: 'characters',
  passwordErrors: 'Passwords do not match. Try again',
  nameAndSurnameError: 'Enter your full name to complete your profile',
  chargeError: 'Tell us your position at school to complete your profile',
  photoError: 'Failed to upload the photo. Try uploading a .PNG or .JPG image file under 2MB.',
  photoAlt: 'Profile photo',
  emailError: 'Enter your email address.',
  cellPhoneNumberError: 'Enter your phone number.',
  schoolNameError: 'Enter the name of your school.',
  schoolAddressError: 'Enter the address of your school.',
  termsAndConditionsError: 'You must accept the terms and conditions',
  duplicatedMail: 'Email address is already registered',
  duplicatedAddres: 'Address is already registered',
  backendOffline: 'We couldn\'t process your request, try again later.'
}

export const ca = {
  title: 'Estàs a un pas d\'accedir a tots els nostres programes educatius!',
  repeatedUserWarning: 'Recorda que si el teu centre educatiu ja forma part de la comunitat Kimple, no cal que sol·licitis un usuari trial. Demana-li al teu equip directiu que t\'enviï la invitació per poder generar el teu registre i accedir a les credencials definitives.',
  continueWithGoogle: 'Continuar amb Google',
  continueWithMicrosoft: 'Continuar amb Microsoft',
  schoolInformation: 'Informació de l\'escola',
  personalInformation: 'Informació personal',
  repeatEmailLabel: 'Confirmar correu electrònic',
  repeatEmailError: 'Confirma el correu electrònic',
  passwordMinLengthError: 'Mínim 6 caràcters',
  passwordUpperLowerError: 'Almenys una majúscula i una minúscula',
  passwordNumberError: 'Almenys un número',
  repeatEmailDifferentError: 'Les dades ingressades no són correctes',
  repeatEmailPlaceholder: 'Confirma el correu electrònic',
  titleNewUser: 'Completa el teu perfil',
  titleExistingUser: 'Verifica el teu perfil abans de confirmar el canvi',
  enterPasswordExistingUser: 'Ingressa la teva contrasenya per confirmar el canvi',
  button: 'Enviar',
  termsAndConditions: 'Termes i condicions',
  accept: 'Estic d\'acord amb ',
  nameAndSurnamePlaceholder: 'Escriu el teu nom',
  nameAndSurnameLabel: 'Nom i cognoms',
  emailLabel: 'Correu electrònic',
  emailPlaceholder: 'Escriu el teu correu electrònic',
  schoolNameLabel: 'Nom de l\'escola',
  schoolNamePlaceholder: 'Càrrec que exerceix a l\'escola',
  educationalLevelsLabel: 'Nivell',
  educationalLevelsPlaceholder: 'Selecciona el nivell que imparteix l\'escola',
  educationalLevelsError: 'Has de seleccionar almenys un nivell',
  chargePlaceholder: 'Càrrec que exerceix a l\'escola',
  chargeLabel: 'Àrea',
  bioPlaceholder: 'Escriu una biografia curta',
  bioLabel: 'Bio',
  levelPlaceholder: 'Indica el nivell o nivells amb què treballes',
  levelLabel: 'Nivell',
  subjectPlaceholder: 'Afegeix les assignatures que imparteixes',
  subjectLabel: 'Assignatures que imparteixes',
  phonePlaceholder: 'Introdueix el número de telèfon',
  phoneLabel: 'Telèfon',
  passwordPlaceholder: 'Escriu una paraula de pas',
  passwordLabel: 'Paraula de pas',
  replacePasswordLabel: 'Repeteix la paraula de pas',
  replacePasswordPlaceholder: 'Repeteix la paraula de pas',
  replacePasswordError: 'Repeteix la paraula de pas',
  replacePasswordDifferentError: 'Les dades ingressades no són correctes',
  bioTip: 'Explica\'ns una mica qui ets en menys de 400 caràcters.',
  passwordTip: 'Ha de tenir: com a mínim 6 caràcters, d\'entre els quals 1 majúscula, 1 minúscula i 1 número (0~9)',
  photoLabel: 'Foto de perfil',
  photoButton: 'Puja foto',
  optional: '(Opcional)',
  characters: 'caràcters',
  passwordErrors: 'Les paraules de pas no coincideixen. Prova un altre cop',
  nameAndSurnameError: 'Escriu el teu nom sencer per completar el teu perfil',
  chargeError: 'Indica\'ns quin és el teu càrrec a l\'escola per completar el teu perfil',
  photoError: 'No hem pogut pujar la teva imatge. Prova de pujar una altra en format .PNG o .JPG amb un pes inferior a 2 MB.',
  photoAlt: 'Foto de perfil',
  emailError: 'Escriu la teva adreça de correu electrònic.',
  cellPhoneNumberError: 'Escriu un número de telèfon.',
  schoolNameError: 'Escriu el nom de la teva escola.',
  schoolAddressError: 'Escriu l\'adreça de la teva escola.',
  termsAndConditionsError: 'Has d\'acceptar els termes i condicions',
  duplicatedMail: 'Aquest correu electrònic ja està registrat',
  duplicatedAddres: 'Aquesta direcció ja està registrada',
  backendOffline: 'No podem atendre la teva sol·licitud, intenta-ho més tard.'
}
